import React from 'react';
import { initialStateReducer, StateAuth, ActionAuth } from './AuthReducer'
const AuthContext = React.createContext<{
    state: StateAuth;
    dispatch: React.Dispatch<ActionAuth>;
}>({
    state: initialStateReducer,
    dispatch: () => null
});

export default AuthContext;